/* eslint-disable no-mixed-spaces-and-tabs */
import { Component, Input, OnChanges, SimpleChanges, ViewChild, forwardRef, inject, output } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { PanelMenu, PanelMenuModule } from 'primeng/panelmenu';
import { BadgeModule } from 'primeng/badge';
import { MenuItem } from 'primeng/api';
import { EXPAND_ALL_SQUARE_BUTTON } from '../../shared/common-config/button.config';
import { ButtonComponent } from "./button.component";
import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from '../shared.module';
import { Chip, ChipComponent } from "./chip.component";

@Component({
	selector: 'ui-ng-panel-menu',
	standalone: true,
	template: `
  <div class="flex flex-column justify-content-start w-full    " style="max-height:75vh;">
	
  @if(!collapsed){
	  <div class="flex mt-2 ">
		  <ui-ng-chip [disable_hover]="true" [chips]="[
			{
				label:getExpanded() ? 'COLLAPSE ALL SECTIONS' : 'EXPAND ALL SECTIONS',
				icon: getExpanded() ? 'fa-solid fa-chevron-down' : 'fa-solid fa-chevron-right' ,  
				styleClass:' cursor-pointer border-red-200 bg-white text-grey font-medium shadow-1 text-xs select-none gap-2  ',
			}
		  ]" style="font-size: 12px;width: 100%;" (click)="collapseExpandAll(!expanded);$event.stopImmediatePropagation()"></ui-ng-chip>
		  
	  </div>
  }
	<div [class]="'overflow-x-hidden  flex flex-column '  + (collapsed ? '':'overflow-y-scroll ')">
		<p-panelMenu #panel [model]="items" [ngClass]="'w-full   '" [styleClass]="'panelMenuClass w-full ' + (collapsed ? ' collapsed ' : ' pl-3 pr-1 ') " translate>
			<ng-template pTemplate="item" let-item>
				<span pRipple [class]="' flex w-full justify-content-start align-items-center cursor-pointer ' + (!collapsed ? ' py-2 pl-3 gap-2   ' : !item.icon_image ? ' -pl-2 ' : '')"
  					[routerLink]="item.routerLink ?? item.router_link"
					  routerLinkActive="menu-active-item"
					  >
  					<!-- routerLinkActive="p-menuitem-link-active" -->
  					@if(item.icon_image){
						@if(!collapsed){
							<img [style]="'margin-left: 0rem; width:15px;height:15px;'" [src]="'../../../assets/images/'+item.icon_image" alt=""/>
						}@else{
							<img [style]="'margin-left: 1.2rem; width:20px;height:20px;'" [src]="'../../../assets/images/2'+item.icon_image" alt=""/>
						}
					}
					@if(!collapsed){
						@if(!item.icon_image){
							<i [class]="item.icon + ' text-primary '"></i>
						}
						<span class="ml-2 color_text">
							{{ item.label }}
						</span>
						
					}
        		</span>
    		</ng-template>
		</p-panelMenu>
	</div>

</div>
`,
	styles: `
	 ::ng-deep .menu-active-item {
		background-color: rgba(31, 38, 135, 0.2) !important;
		color: var(--primary-color) !important;
		font-weight: bold;
		border-radius: 8px;
		padding:0.5rem 1rem 0.5rem 0rem;
		padding-right: 1rem;
		
	}
	span.color_text {
	color: #4b5563 !important; 
	}

	span.color_text:hover {
	color: #4b5563 !important;
	}

	.collapsed{
		min-height:100% !important;
	}
    ::ng-deep .p-panelmenu.panelMenuClass {
	/** Tree structure when collapsed */
	}
 	::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel {
	/**Focused item style */
	margin-block: 0.75rem !important;

	/**Toggleable content item style */
	}
	::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-panelmenu-header {
	}
 	::ng-deep .p-panelmenu.panelMenuClass.collapsed .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content {
	
		background-color: transparent !important;
		display: flex !important;
		justify-content: start !important;
		align-items: center !important;
		padding: 0!important;

	}
	
	
	::ng-deep .p-panelmenu.panelMenuClass:not(.collapsed) .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content {
		background: rgba( 255, 255, 255, 0.9 );
		box-shadow: 0 1px 22px 0 rgba( 31, 38, 135, 0.37 );
		backdrop-filter: blur( 20px );
		-webkit-backdrop-filter: blur( 20px );
		border-radius: 10px ;
		border: 1px solid rgba( 255, 255, 255, 0.18 );
	    transition: all 0.2s ease-out !important;
		display: flex !important;
		justify-content: start !important;
		align-items: center !important;
		padding: 0!important;
	}
	




::ng-deep .p-panelmenu.panelMenuClass:not(.collapsed) .p-panelmenu-panel .p-panelmenu-header.p-highlight {
    /* Stile per l'header del tab attivo */
}
 ::ng-deep .p-panelmenu.panelMenuClass:not(.collapsed) .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content:hover {
	 background: var(--surface-100) !important;

	 
}
::ng-deep .p-panelmenu.panelMenuClass.collapsed .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content:hover .p-panelmenu-header-action {
	 color: var(--surface-400) !important;
	
 }
 ::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content:hover .p-panelmenu-header-action {
	 color: var(--secondary-color) !important;
}

 ::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-action {
	 transition: all 0.3s ease-out !important;
	 padding: 0.7rem !important;
	background-color:transparent !important;
}

 ::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-action .p-icon-wrapper {
	 transition: all 0.3s ease-out !important;
}
 ::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-action .p-icon-wrapper .p-submenu-icon {
	 transition: all 0.3s ease-out !important;
}
 ::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-action .p-menuitem-icon {
	 transition: all 0.3s ease-out !important;
	 font-size: 1rem !important;
	 padding-inline: 0.5rem !important;
}

 ::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus > .p-menuitem-content {
	 color: transparent !important;
	 background-color: transparent !important;
	 box-shadow: none !important;  
}

 ::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus > .p-menuitem-content .p-menuitem-link  {
	 background: rgba( 255, 255, 255, 0.3 );
	 box-shadow: 0 1px 4px 0 rgba( 31, 0, 135, 0.37 );
	 -webkit-backdrop-filter: blur( 20px );
	 transition: 0.1s !important; 
	 border: none !important;
	 color: var(--primary-color) !important;


}

::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-toggleable-content .p-panelmenu-content {
	margin-top:5px;
	padding-top:-10px;
	background: rgba( 255, 255, 255, 0.9 );
box-shadow: 0 1px 4px 0 rgba( 31, 0, 135, 0.15 );
backdrop-filter: blur( 20px );
-webkit-backdrop-filter: blur( 20px );
border-radius: 10px 10px 10px 10px;
border: 1px solid rgba( 255, 255, 255, 0.18 );
/**Container of icon text and label */
}

::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-toggleable-content .p-panelmenu-content a {
	 display: flex !important;
	 align-items: center !important;
}
::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-toggleable-content .p-panelmenu-content a .p-menuitem-icon {
	 padding-inline: 0.25rem !important;
}

::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-toggleable-content .p-panelmenu-content a:hover {
background: rgba( 255, 255, 255, 0.3 );
box-shadow: 0 1px 4px 0 rgba( 31, 0, 135, 0.37 );
-webkit-backdrop-filter: blur( 20px );
transition: 0.1s !important; 

}

::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-toggleable-content .p-panelmenu-content a:hover .p-submenu-icon {
	 color: var(--tab-hover-color) !important;

}
 ::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-toggleable-content .p-panelmenu-content a:hover .p-icon-wrapper {
	 color: var(--tab-hover-color) !important;

}
 ::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-toggleable-content .p-panelmenu-content a:hover .p-menuitem-icon {
	 color: var(--tab-hover-color) !important;
	 padding-inline: 0.25rem !important;
}
 ::ng-deep .p-panelmenu.panelMenuClass .p-panelmenu-panel .p-toggleable-content .p-panelmenu-content a:hover .p-menuitem-text {
	 color: var(--tab-hover-color) !important;
}
 ::ng-deep .p-panelmenu.panelMenuClass.collapsed .p-panelmenu-panel .p-panelmenu-header {
	 margin-block: 0.5rem !important;
	 transition: all 0.63s ease-out !important;
	 background-color: none !important;

	 
}

 ::ng-deep .p-panelmenu.panelMenuClass.collapsed .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content {
	 border: none !important;
	 display: flex !important;
	 justify-content: center !important;
	 transition: all 0.63s ease-out !important;
}
 ::ng-deep .p-panelmenu.panelMenuClass.collapsed .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-action {
	 color: white !important;
	 background-color: none !important;

}
 ::ng-deep .p-panelmenu.panelMenuClass.collapsed .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-action .p-icon-wrapper {
	 visibility: hidden !important;
	 width: 0 !important;
}
 ::ng-deep .p-panelmenu.panelMenuClass.collapsed .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-action .p-menuitem-icon {
	 font-size: 1rem !important;

}
 ::ng-deep .p-panelmenu.panelMenuClass.collapsed .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-action .p-menuitem-text {
	 visibility: hidden !important;
	 width: 0 !important;
}
 ::ng-deep .p-panelmenu.panelMenuClass.collapsed .p-panelmenu-panel .p-panelmenu-header .p-panelmenu-header-content .p-panelmenu-header-action .p-menuitem-badge {
	 visibility: hidden !important;
	 width: 0 !important;
	background-color:red!important;

}
 `,
	providers: [TranslateService],
	imports: [CommonModule, PanelMenuModule, BadgeModule, forwardRef(() => ButtonComponent), SharedModule, ChipComponent]
})
export class PanelMenuComponent implements OnChanges {
	expand_button = EXPAND_ALL_SQUARE_BUTTON
	@Input() collapsed = true;
	@ViewChild('panel', { static: false }) pnl: PanelMenu | undefined;
	@Input() expanded = false;
	expandedChange = output<boolean>();
	collapsedChange = output<boolean>();
	location: Location = inject(Location);
	translate: TranslateService = inject(TranslateService);
	@Input({ transform: (items: UIMenuItem[] | undefined) => items?.map(i => ({ ...i, label: i.label ?? i.id })) }) items: UIMenuItem[] | undefined;
	stored_items: { [x: string]: MenuItem[] | undefined } = {};
	chip: Chip[] = [

	]



	constructor() {
		this.translate.setDefaultLang('it');
		this.translate.use('it');
		// //console.logthis.translate.instant('home'))
	}
	collapseAll() {
		this.pnl?.collapseAll();
	}

	collapseExpandAll(expanded: boolean) {
		// // //console.log"Expanded collapse", expanded);
		if (!expanded) {
			this.pnl?.collapseAll()
		} else if (this.items) {
			this.items = this.toggleAllRecursive(this.items, expanded);
			// // //console.log"Expanding items", this.items);
		}
		this.expanded = expanded;
	}

	ngOnChanges(changes: SimpleChanges) {
		// //console.log"changes ", changes);
		if (changes["items"]) {
			this.items = this.translateRecursive(this.items);
		}
		if (changes['collapsed'] && this.items && (changes['collapsed'].currentValue !== changes['collapsed'].previousValue)) {
			if (this.collapsed) {
				this.items = this.removeItems(this.items)
			} else {
				this.items = this.addStoredItems(this.stored_items);
				// //console.log"items added, expanding",) 
				const path = this.location.path().split('/')[this.location.path().split('/').length - 1];
				this.items = this.expandUntil(this.items!, path, 'id');

			}
		}
		if (changes['expanded'] && (changes['expanded'].currentValue !== changes['expanded'].previousValue) && this.items) {
			// // //console.log"Changes expanded", this.expanded);
			this.items = this.toggleAllRecursive(this.items, this.expanded);

		}
	}


	private toggleAllRecursive(items: UIMenuItem[], expanded: boolean): MenuItem[] {
		return items.map((menuItem) => {
			menuItem.expanded = expanded;
			if (menuItem.items) {
				menuItem.items = this.toggleAllRecursive(menuItem.items, expanded);
			}
			return menuItem;
		});
	}

	private removeItems(items: UIMenuItem[]): UIMenuItem[] | undefined {
		return items.map((item) => {

			const { items, ...menuItem } = item
			const label: string = menuItem.label!
			this.stored_items = {
				...this.stored_items, [label]: items
			}
			return { ...menuItem, routerLink: menuItem.router_link }
		})
	}

	private addStoredItems(stored_items: { [x: string]: MenuItem[] | undefined; }): UIMenuItem[] | undefined {
		return this.items?.map(i =>
			({ ...i, routerLink: stored_items[i.label!] ? null : i.routerLink, items: stored_items[i.label!] })
		)
	}

	private expandUntil(items: MenuItem[], value: string, field_name: string) {
		return items.map(item => {
			// // //console.log"Searching in ", item, this.searchItemsNode(item,value,field_name)) 
			if (this.searchItemsNode(item, value, field_name)) {
				// // //console.log"Taking op")
				item = this.expandUntilNodeIndexRecursive(item, true, value, field_name);
			}
			return item;
		})
	}

	translateRecursive(items: MenuItem[] | undefined): MenuItem[] | undefined {
		return items?.map(item => {
			// // //console.log"Recursive ", this.translate.instant(item.label ?? item.id ?? ''))
			return {
				...item,
				label: this.translate.instant(item.label ?? item.id ?? ''),
				items: this.translateRecursive(item.items)
			}
		}
		)
	}

	private expandUntilNodeIndexRecursive(node: MenuItem, isExpand: boolean, node_label: string, field_name: string): MenuItem {
		node.expanded = isExpand;
		let found = node[field_name] === node_label || false;
		if (node.items) {
			node.items.forEach((childNode) => {
				if (childNode[field_name] && childNode[field_name] === node_label) {
					found = true;
				}
				if (!found) {
					this.expandUntilNodeIndexRecursive(childNode, isExpand, node_label, field_name);
				} else {
					this.toggleAllRecursive([childNode], false);
				}
			});
		}
		return node
	}

	private searchItemsNode(node: MenuItem, label: string, field_name: string) {
		if (node[field_name] === label) {
			// // //console.log"found child node in label ");
			return true;
		} else if (node.items) {
			// eslint-disable-next-line prefer-const
			let result: boolean[] = [];
			node.items.forEach(childNode => {
				result.push(this.searchItemsNode(childNode, label, field_name))
			})
			return result.some(r => r === true);
		} else {
			return false;
		}
	}

	getExpanded() {
		return this.items!.filter(item => item.expanded).length === this.items!.length
	}


}

export type UIMenuItem = MenuItem & { router_link?: string }

